import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

let nextTeacherTooltip = 0;
export default function TeacherIdentity({ teacher }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [tooltipId] = useState(() => `portal-teacher-${++nextTeacherTooltip}`);
  const container = useRef(null);
  const button = useRef(null);
  const names = teacher ? [teacher.firstName, teacher.lastName].filter(value => typeof value === 'string' && value.trim()).map(value => value.trim()) : [];
  const name = names.join(' ');
  useEffect(() => {
    if (!open) return undefined;
    const outside = event => { if (container.current && !container.current.contains(event.target)) setOpen(false); };
    document.addEventListener('mousedown', outside);
    document.addEventListener('touchstart', outside);
    return () => { document.removeEventListener('mousedown', outside); document.removeEventListener('touchstart', outside); };
  }, [open]);
  if (!name) return <div className="client-portal__teacher">{t('client:schedule.teacherUnavailable')}</div>;
  return (
    <div className="client-portal__teacher" ref={container}>
      <span>{t('client:schedule.teacher')}</span>
      <button
        type="button"
        ref={button}
        className="client-portal__teacher-initials"
        aria-label={t('client:schedule.teacherName', { name })}
        aria-describedby={open ? tooltipId : undefined}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => { if (document.activeElement !== button.current) setOpen(false); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={() => setOpen(true)}
        onKeyDown={event => { if (event.key === 'Escape') { event.stopPropagation(); setOpen(false); } }}
      >{names.map(value => Array.from(value)[0]).join('').toLocaleUpperCase()}
      </button>
      {open && <span className="client-portal__teacher-tooltip" id={tooltipId} role="tooltip">{name}</span>}
    </div>
  );
}
TeacherIdentity.propTypes = { teacher: PropTypes.shape({ firstName: PropTypes.string, lastName: PropTypes.string }) };
TeacherIdentity.defaultProps = { teacher: null };
